import React, { Suspense, lazy } from 'react';
import { LANGUAGE_CODE } from '../common/LocaleSelector';
import { store } from '../store';

const Ko = lazy(() => import('./Ko'));
const En = lazy(() => import('./En'));
const Ar = lazy(() => import('./Ar'));
const Id = lazy(() => import('./Id'));
const Ja = lazy(() => import('./Ja'));
const Ru = lazy(() => import('./Ru'));
const Th = lazy(() => import('./Th'));
const Zh = lazy(() => import('./Zh'));

export const Index = ({ children }: { children: React.ReactNode }) => {
    const locale = store.getState().main.config.locale;

    return (
        <Suspense>
            {locale === LANGUAGE_CODE.ko ? <Ko /> : null}
            {locale === LANGUAGE_CODE.en ? <En /> : null}
            {locale === LANGUAGE_CODE.ar ? <Ar /> : null}
            {locale === LANGUAGE_CODE.id ? <Id /> : null}
            {locale === LANGUAGE_CODE.ja ? <Ja /> : null}
            {locale === LANGUAGE_CODE.ru ? <Ru /> : null}
            {locale === LANGUAGE_CODE.th ? <Th /> : null}
            {locale === LANGUAGE_CODE.zh ? <Zh /> : null}
            {children}
        </Suspense>
    );
};
